import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import useStore from 'store';

const useStyles = makeStyles(theme => ({
  root: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  avatarItem: {
    marginLeft: -theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  button: {
    borderRadius: 3
  },
  selected: {
    color: 'white',
    backgroundColor: `${theme.palette.secondary.main} !important`
  },
  visibilityOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  visibilityClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
}));

type ClickFuntion = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
interface AvatarListItemProps {
  open?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  selected: boolean;
}

const AvatarListItem = ({ open, onClick, selected }: AvatarListItemProps): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation('AvatarNavigationItem');
  const [
    {
      user: { me }
    }
  ] = useStore();
  const userInitials = me && me?.firstName.charAt(0) + me?.lastName.charAt(0);
  const name = me && `${me?.firstName} ${me?.lastName}`;

  return (
    <ListItem
      button
      selected={selected}
      onClick={onClick}
      classes={{
        button: clsx({ [classes.button]: open }),
        selected: classes.selected
      }}
    >
      <ListItemAvatar className={classes.avatarItem}>
        <Avatar alt={name} src={me?.avatarUrl || ''}>
          {!me?.avatarUrl && userInitials}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        className={clsx({
          [classes.visibilityOpen]: open,
          [classes.visibilityClose]: !open
        })}
        primary={`${t('Hi')}, ${name}`}
      />
    </ListItem>
  );
};

export default AvatarListItem;
